<div fxLayout="column" class="dial-creds" [ngStyle]="{'max-height.px': innerHeight}">

    <div fxLayout="column" fxLayoutGap="10px" class="layout-padd-6">

        <div fxLayoutAlign="center center">
            <i class="fas fa-exclamation-circle" [ngClass]="validProvider + '-color'" style="font-size: 1.6em;"></i>
        </div>

        <div fxLayoutAlign="center center" class="text-center">
            <span class="mat-subheading-1">{{ 'dialogs.samecred.text' |
                translate:{'currentProvider':currentProvider, 'validProvider': validProvider} }}</span>
        </div>

    </div>

    <div fxLayoutAlign="center center" fxLayoutGap="10px" class="clicked layout-padd" [ngClass]="validProvider + '-bg'"
        (click)="signInDial()" angulartics2On="click" angularticsAction="selectSuggestedSocial"
        angularticsCategory="login">
        <div>
            <span class="mat-subheading-2">{{"dialogs.samecred.button" | translate}}</span>
        </div>
        <div [ngClass]="['fab', 'fa-'+ validProvider]"></div>
    </div>


</div>